

export class VehicleDetailsApplicationOutput implements IVehicleDetailsApplicationOutput {
    /** The auto-generated id of the tbl vehicle details application module master */
    vehicle_details_application_module_id!: number;
    /** The auto-generated id of the vehicle details master */
    vehicle_details_id!: number;
    /** The auto-generated id of the application module master */
    application_module_id!: number;
    /** The vehicle type name with 50 character limit */
    application_module_name!: string;

    constructor(data?: IVehicleDetailsApplicationOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vehicle_details_application_module_id = _data["vehicle_details_application_module_id"];
            this.vehicle_details_id = _data["vehicle_details_id"];
            this.application_module_id = _data["application_module_id"];
            this.application_module_name = _data["application_module_name"];
        }
    }

    static fromJS(data: any): VehicleDetailsApplicationOutput {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleDetailsApplicationOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vehicle_details_application_module_id"] = this.vehicle_details_application_module_id;
        data["vehicle_details_id"] = this.vehicle_details_id;
        data["application_module_id"] = this.application_module_id;
        data["application_module_name"] = this.application_module_name;
        return data; 
    }
}

export interface IVehicleDetailsApplicationOutput {
    /** The auto-generated id of the tbl vehicle details application module master */
    vehicle_details_application_module_id: number;
    /** The auto-generated id of the vehicle details master */
    vehicle_details_id: number;
    /** The auto-generated id of the application module master */
    application_module_id: number;
    /** The vehicle type name with 50 character limit */
    application_module_name: string;
}

